import { render, staticRenderFns } from "./oneToOneVideoRoom.vue?vue&type=template&id=f8e66e60&scoped=true"
import script from "./oneToOneVideoRoom.vue?vue&type=script&lang=js"
export * from "./oneToOneVideoRoom.vue?vue&type=script&lang=js"
import style0 from "./oneToOneVideoRoom.vue?vue&type=style&index=0&id=f8e66e60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e66e60",
  null
  
)

export default component.exports